import React from 'react';
import Slide from '@material-ui/core/Slide';
import NotificationsNoneRounded from '@material-ui/icons/NotificationsNoneRounded';
import CloseRounded from '@material-ui/icons/CloseRounded';

import classes from './styles.module.css';
import { path, isEmptyList } from '../../utils';
import ThemedIconButton from '../Button/Icon';

export default class NotificationManager extends React.PureComponent {

    maxMessages = 1;
    messageDuration = 5000;
    queueShiftDelay = 500;

    state = {
        enquedMessages: [],
        messages: [],
    };

    enqueMessage = (content, props) => {
        const id = `${new Date().getTime()}_${Math.random()}`;
        const message = { id, props, content, visible: false };

        if (this.state.messages.length >= this.maxMessages) this.setState(prevState => ({ enquedMessages: [].concat(prevState.enquedMessages).concat(message) }));
        else this.setState(prevState => ({ messages: [].concat(prevState.messages).concat(message) }), () => this._mountMessages(id));
    }

    _mountMessages = id => this._toggleMessageVisiblity(id, true);

    _unMountMessages = id => this._toggleMessageVisiblity(id, false);

    _toggleMessageVisiblity = (id, visible) => {
        const { messages } = this.state;
        for (let i = 0; i < messages.length; i++) if (messages[i].id === id) messages[i].visible = visible;
        this.setState({ messages: [].concat(messages) });
    }

    _onMessageEntered = message => setTimeout(() => this._unMountMessages(message.id), path(message.props, 'duration', this.messageDuration));

    _removeMessageFromState = id => {
        const { messages } = this.state;
        for (let i = 0; i < messages.length; i++) if (messages[i].id === id) messages.splice(i, 1);
        this.setState({ messages: [].concat(messages) });
    }

    _shiftMessageQueue = () => {
        const { messages, enquedMessages } = this.state;
        if (isEmptyList(enquedMessages)) return;

        const [message] = enquedMessages.splice(0, 1);
        this.setState({ messages: [].concat(messages).concat(message), enquedMessages: [].concat(enquedMessages) }, () => this._mountMessages(message.id));
    }

    _onMessageClose = message => {
        typeof path(message, 'props.onClose') === 'function' && message.props.onClose();
        this._unMountMessages(message.id);
    }

    componentDidUpdate = () => {
        if (this.state.enquedMessages.length > 0 && this.state.messages.length < this.maxMessages) setTimeout(this._shiftMessageQueue, this.queueShiftDelay);
    }

    render = () => <div className='topCenter messageIndex' style={{ display: 'flex', flexDirection: 'column-reverse' }}>{this.state.messages.map(message => message != null &&
        <Slide key={message.id} in={message.visible} direction='down'
            onEntered={() => this._onMessageEntered(message)}
            onExited={() => this._removeMessageFromState(message.id)}>

            {renderNotification(message, () => this._onMessageClose(message))}

        </Slide>
    )}</div>;

}

const renderNotification = (notification, onClose) => {
    switch (path(notification.props, 'type')) {
        case 'custom': return notification.content;
        default: return <Notification {...notification.props} content={notification.content} onClose={onClose} />;
    }
};

export const Notification = React.memo(React.forwardRef(({ content, action, onActionClick, closeIcon, onClose, ...props }, ref) =>
    <div className={classes.notification} {...props} ref={ref}>
        <NotificationsNoneRounded style={{ height: 22, width: 22, padding: '16px 0px 16px 16px' }} />
        <div className={classes.content}>{content}</div>
        <ThemedIconButton centerRipple={false} onClick={onClose} size='small' rootStyles={{ margin: '10px !important', padding: '6px !important' }}>
            <CloseRounded style={{ height: 20, width: 20, opacity: 0.85 }} />
        </ThemedIconButton>
    </div>
));